import type { MessagesProps } from '@gov-design-system-ce/react-form';
import { FormMessage } from '@gov-design-system-ce/react-form';
import {
	GovAttachments,
	GovAttachmentsItem,
} from '@gov-design-system-ce/react/gov-attachments';
import type { FileUploadItem } from '@gov-nx/core/hooks/File/fileUpload.types';
import { FileState } from '@gov-nx/core/hooks/File/fileUpload.types';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service/translations/name-space.types';
import type { UncheckedKey } from '@gov-nx/core/service/translations/translation.types';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { formatBytes } from '@gov-nx/utils/common/File/file-size';

const color = (fileState: FileState) => {
	if (fileState === FileState.success || fileState === FileState.error) {
		return fileState;
	}
	return 'neutral';
};

export interface FormUploadAttachmentsProps {
	files: FileUploadItem[];
	onRemove: (fileId: string) => void;
}

export const FormUploadAttachments = ({
	files,
	onRemove,
}: FormUploadAttachmentsProps) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Form);
	const messages = (file: FileUploadItem): MessagesProps['messages'] => {
		if (file.message) {
			return {
				color: color(file.state),
				children: t<UncheckedKey>(file.message.key, file.message.values),
			};
		}
		return [];
	};

	if (files.length === 0) {
		return null;
	}

	return (
		<div>
			<h2 className="mt-4! text-headline-s!">{t('nahrani-souboru.prilohy')}</h2>
			<GovAttachments>
				{files
					.sort((a, b) => a.index - b.index)
					.map((file) => (
						<GovAttachmentsItem
							key={file.id}
							accessibleRemoveLabel={t(
								'nahrani-souboru.wcag.odstranit-soubor',
								{
									fileName: file.name,
								}
							)}
							onRemove={() => onRemove(file.id)}
							info={<span>({formatBytes(file.size)})</span>}
							message={
								<div>
									<FormMessage messages={messages(file)} />
								</div>
							}>
							{file.name}
						</GovAttachmentsItem>
					))}
			</GovAttachments>
		</div>
	);
};
